// extracted by mini-css-extract-plugin
module.exports = {"headerNavV3Wrapper":"HeaderNavTabs_headerNavV3Wrapper__iEJ1d"};